export enum CapabilityModelSchemaDataType {
    Unknown,
    Number,
    Text,
    Boolean,
}
